import { Button, Col, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import LiveIcon from "../../../assets/icons/live-icon.svg";
import BellImg from "../../../assets/images/bell.webp";
import useFetchPublicProfileEvent from "../../../hooks/userHooks/useFetchPublicProfileEvent";
import liveUtil from "../../../utls/LiveUtil";

interface Props {
  creatorId: string;
  onTakeTicketClick: () => void;
}

const PublicProfileEvent: React.FC<Props> = ({ creatorId, onTakeTicketClick }) => {
  const { t } = useTranslation();
  const { scheduledEvent } = useFetchPublicProfileEvent(creatorId);

  if (!scheduledEvent) return null;

  return (
    <Row className="editLive-container mb-20 mt-10">
      <Col className="editLive-content">
        <Row>
          <Typography.Text className="editLive-title mt-5">
            <img src={LiveIcon} width={30} alt="" />{" "}
            {liveUtil.getScheduleDateTimeStringForProfile(t, scheduledEvent.scheduleData?.dateTime || "")}
          </Typography.Text>
        </Row>
        <Row>
          <Typography.Text className="editLive-description">{t("take-ticket-live")}</Typography.Text>
        </Row>
        <Row className="w-full">
          <Button className="editLiveButton" onClick={onTakeTicketClick}>
            {t("take-ticket")}
          </Button>
        </Row>
      </Col>
      <Col className="editLive-image">
        <img src={BellImg} width={120} alt="" />
      </Col>
    </Row>
  );
};

export default PublicProfileEvent;
